
const initialState = {
  loading: false,
  newPass: false,
  error: false,
  termsListing: [],
  termsDetail: null
};

const termsReducer = (state = initialState, action) => {
  // console.log("privacy  reducers------", state, action);
  switch (action.type) {
    case "ADD_TERMS_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ADD_TERMS_SUCCESS":
      return {
        ...state,
        loading: false,
        newPass: true,
        error: false,
      };
    case "ADD_TERMS_FAILED":
      return {
        ...state,
        loading: false,
        newPass: false,
        error: true,
      };

    case "GET_TERMS_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_TERMS_REQUEST_FAILED":
      return {
        ...state,
        error: true,
      };
    case "GET_TERMS_REQUEST_SUCCESS":
      return {
        ...state,
        termsListing: action.payload,
        loading: false,
      };


    case "GOT_TERMS_DETAIL":
      return {
        ...state,
        termsDetail: action.payload,
      };
    default:
      return state;
  }
};

export default termsReducer;
